import { useCallback } from "react";
import { selectIsHealthy } from "src/stores/redux/features/striim-ai/striim-ai.slice";

import copilotService from "core/services/copilotService";
import { useAppSelector } from "src/stores/redux/hooks";
import { clearConnectionErrorShown } from "src/modules/striim-ai-sidebar/utils/health-check.utils";

export const useStriimAIConfig = () => {
    const { isEnabled, copilotUrl, healthStatus, isConfigured, isLoading } = useAppSelector(state => state.striimAi);
    const isHealthy = useAppSelector(selectIsHealthy);

    const recheckConfiguration = useCallback(() => {
        clearConnectionErrorShown();
        return copilotService.recheckConfiguration().then(() => undefined);
    }, []);

    const pollUntilHealthy = useCallback(
        (maxTries?: number, intervalMs?: number) => copilotService.pollUntilHealthy(maxTries, intervalMs),
        []
    );

    return {
        isEnabled,
        isConfigured,
        copilotUrl,
        isLoading,
        healthStatus,
        isHealthy,
        recheckConfiguration,
        pollUntilHealthy
    };
};
